import { usePage } from '@inertiajs/react';
import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

interface FlashBag {
    success?: string;
    error?: string;
    warning?: string;
    info?: string;
}

/**
 * Bridges Laravel flash messages (shared globally via HandleInertiaRequests)
 * to sonner toasts on every Inertia navigation, so any controller that does
 * `->with('success', ...)` surfaces consistently app-wide without each page
 * having to wire it up.
 */
export function FlashToaster() {
    const page = usePage();
    const flash = (page.props.flash ?? {}) as FlashBag;
    // De-duplicate: StrictMode double-invokes effects and props identity is
    // stable across unrelated re-renders.
    const last = useRef<string>('');

    useEffect(() => {
        const signature = JSON.stringify(flash);
        if (signature === last.current) return;
        last.current = signature;

        if (flash.success) toast.success(flash.success);
        if (flash.error) toast.error(flash.error);
        if (flash.warning) toast.warning(flash.warning);
        if (flash.info) toast.info(flash.info);
    }, [flash]);

    return null;
}
